import type { IUser } from '@/models/users';
import { getActiveMerchantId } from '@/utils/axios.utils';
import type {
  ModelUserResponse,
  UserServiceApiUserServiceCreateRequest,
  UserServiceApiUserServiceUpdateRequest,
} from '@layup/api-sdk';
import { userServiceClient } from './auth';

export const getUsersByMerchant = async (): Promise<ModelUserResponse[]> => {
  const response = await userServiceClient().userServiceGetMany();
  return response.data.users as ModelUserResponse[];
};

export const updateUser = async (params: UserServiceApiUserServiceUpdateRequest): Promise<ModelUserResponse> => {
  const config = getActiveMerchantId();
  const response = await userServiceClient().userServiceUpdate(params, config);
  return response.data;
};

export const addMerchantUser = async (params: UserServiceApiUserServiceCreateRequest) => {
  const response = await userServiceClient().userServiceCreate(params);
  return response.data;
};
